<template>
    <BuilderBase :loading="datasetStore.loading">
        <template v-slot:section-title>
            <div class="content">
                <h1 class="h1">
                    <span class="steps">{{$t('common.step_1')}} 3<span class="slash">/</span>3:</span> <span class="title" >{{$t('views.dataset_consult.title_short')}}</span>
                </h1>
            </div>
        </template>

        <template v-slot:section-content>
            <ToggleSimple :toggleable="false" :default="true" cssClass="toggle-type-2 important-title">
                <template #toggle>
                    <div class="left">
                        <div class="toggle-text">
                            {{ $t('views.dataset_consult.title') }}
                        </div>
                        <div class="toggle-description" v-html="$t(`views.dataset_consult.description`, { count: formatNumber(datasetStore.count)})"></div>
                        <ul class="list-icon-pos">
                            <li>{{$t('views.dataset_consult.bullets.0')}}</li>
                            <li>{{$t('views.dataset_consult.bullets.1')}}</li>
                            <li>{{$t('views.dataset_consult.bullets.2')}}</li>
                            <li>{{$t('views.dataset_consult.bullets.3')}}</li>
                        </ul>
                    </div>
                </template>

                <template #content>
                    <div class="builder-checkout-type-1">
                        <ConsultForm @form_submission_successful="confirmConsult()" />
                    </div>
                </template>
            </ToggleSimple>
        </template>
    </BuilderBase>
</template>

<script>
    import router from '@/router';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import { useDatasetStore } from '@/stores/dataset';
    import { formatNumber } from '@/utils/formatting';
    import ConsultForm from '@/components/forms/DatasetConsultForm';
    import BuilderBase from '@/views/builder/BuilderBase';
    import ToggleSimple from '@/components/elements/misc/ToggleSimple';

    export default {
        name: 'HomeView',
        mixins: [i18nViewMixin],
        components: {
            ConsultForm,
            BuilderBase,
            ToggleSimple
        },
        data() {
            return {
                seo_title: 'views.dataset_consult.seo_title'
            };
        },
        computed: {
            datasetStore() {
                return useDatasetStore();
            }
        },
        methods: {
            formatNumber,
            confirmConsult() {
                router.push({ name: 'consult-requested' });
            },
        },
        async mounted() {
            if(!this.datasetStore.price || !this.datasetStore.query) {
                const success = await this.datasetStore.fetchDataset(true);
                if(!success || !this.datasetStore.count || !this.datasetStore.price || !this.datasetStore.query) {
                    this.$router.push({name: 'builder'});
                }
            }
        }
    }
</script>